import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex items-center mb-2"
};
const _hoisted_2 = {
  class: "w-24 mr-4"
};
const _hoisted_3 = {
  class: "grow"
};
const _hoisted_4 = {
  class: "mb-2"
};
const _hoisted_5 = {
  class: "flex items-center justify-center border-t p-2 py-4"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { Team } from "@/modules/team/entity";
import Status from "@/modules/vue/components/Status.vue";
import { ColorEnum } from '@/modules/vue/enums';
import { NegotiationStatusEnum } from '@/modules/diplomacy/enums';
import { Progress, ProgressMarker } from "@/modules/vue/components";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const team = ref();
    const currentStatus = ref(NegotiationStatusEnum.OPENED);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      const t = await Team.createQueryBuilder('team').leftJoinAndSelect('team.staffMembers', 'staffMember').leftJoinAndSelect('team.negotiations', 'negotiation', 'status = :status', {
        status: currentStatus.value
      }).leftJoinAndSelect('negotiation.team', 'negotiationTeam').where('team.user = true').getOneOrFail();
      for (const n of t.negotiations) {
        await n.load('target');
      }
      team.value = t;
    })), __temp = await __temp, __restore(), __temp);
    watch(() => currentStatus.value, refresh);
    const statusColors = ref({
      [NegotiationStatusEnum.OPENED]: ColorEnum.Amber,
      [NegotiationStatusEnum.CLOSED]: ColorEnum.Green,
      [NegotiationStatusEnum.FAILED]: ColorEnum.Red
    });
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      const _component_RouterLink = _resolveComponent("RouterLink");
      const _component_NRadio = _resolveComponent("NRadio");
      const _component_NSpace = _resolveComponent("NSpace");
      const _component_NRadioGroup = _resolveComponent("NRadioGroup");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('negotiations')), 1)]),
        submenu: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_NRadioGroup, {
          value: currentStatus.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => currentStatus.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_NSpace, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(NegotiationStatusEnum), status => {
              return _openBlock(), _createBlock(_component_NRadio, {
                key: status,
                value: status,
                label: _ctx.$t(status)
              }, null, 8, ["value", "label"]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        }, 8, ["value"])])]),
        default: _withCtx(() => [_createElementVNode("div", null, [team.value.negotiations.length === 0 ? (_openBlock(), _createBlock(_component_NEmpty, {
          key: 0,
          description: _ctx.$t('no_entries')
        }, null, 8, ["description"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.value.negotiations, n => {
          return _openBlock(), _createElementBlock("div", {
            key: n.id,
            class: "p-2 border-b last:border-b-0"
          }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Status, {
            value: n.status,
            colors: statusColors.value,
            class: "mx-2"
          }, null, 8, ["value", "colors"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(EntityLink, {
            entity: n.target
          }, null, 8, ["entity"])]), _createVNode(_component_RouterLink, {
            class: "grow",
            to: {
              name: 'negotiations.show',
              params: n
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(Progress), {
              value: n.progress,
              class: "mb-3"
            }, {
              default: _withCtx(() => [Number.isInteger(n.progressCloseLimit) ? (_openBlock(), _createBlock(_unref(ProgressMarker), {
                key: 0,
                value: n.progressCloseLimit,
                color: _unref(ColorEnum).Green
              }, null, 8, ["value", "color"])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["value"]), _createVNode(_unref(Progress), {
              value: n.patience,
              class: "mb-2"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ProgressMarker), {
                value: n.patienceAbortLimit,
                color: _unref(ColorEnum).Red
              }, null, 8, ["value", "color"])]),
              _: 2
            }, 1032, ["value"])]),
            _: 2
          }, 1032, ["to"])])])]);
        }), 128))])]),
        _: 1
      });
    };
  }
});